import { useEffect, useState } from "react";
import { GameService } from "./GameService";

export default function PopularGameHook() {
    const [data, setData] = useState([]);

    useEffect(() => {
        GameService.games({ type: "popular_games" }).then(response => {
            setData(response);
        });
    }, []);

    return data;
}